@if (aiContentIndexResponse && hasData()) {
<div class="generic-ai-content-container">

    <!-- Chart 1: Content domains (six metrics) -->
    @if (barChartData.length > 0) {
    <div class="charts-section">
        <div class="chart-container">
            <h3>Content Category Analysis</h3>
            @if (isAdmin && showSectionReloadButton) {
            <div class="section-reload-wrap">
              @if (reloadingSection) {
                <mat-progress-spinner class="section-reload-spinner" diameter="28" mode="indeterminate"></mat-progress-spinner>
              } @else {
                <button type="button" class="section-reload-btn" mat-icon-button (click)="reloadSection()" title="Reload this section only (updates current version)">
                  <mat-icon>refresh</mat-icon>
                </button>
              }
            </div>
            }
            <div class="chart-mobile-wrapper">
                <div class="combo-chart-wrapper">
                    <app-bar-line-combo-chart
                        [view]="chartView"
                        [scheme]="comboBarScheme"
                        [colorSchemeLine]="lineChartScheme"
                        [results]="results"
                        [lineChart]="lineChart"
                        [barBrandName]="(aiContentIndexResponse?.metadata?.your_brand || brands[0]?.name || 'Your Brand')"
                        [animations]="true"
                        [tooltipDisabled]="false"
                        [gradient]="false"
                        [xAxis]="true"
                        [yAxis]="true"
                        [legend]="true"
                        [legendTitle]="'Brands'"
                        [legendPosition]="'right'"
                        [showGridLines]="true"
                        [showXAxisLabel]="true"
                        [showYAxisLabel]="true"
                        [xAxisLabel]="'Content Categories'"
                        [yAxisLabel]="'Score'"
                        (select)="onChartSelect($event)">
                    </app-bar-line-combo-chart>
                </div>
            </div>
        </div>
    </div>
    }

    <!-- Chart 2: Content quality metrics – only when API provides content_quality_metrics -->
    @if (hasContentQualityMetricsFromApi && resultsQuality.length > 0) {
    <div class="charts-section quality-metrics-section">
        <div class="chart-container">
            <h3>Content Quality Metrics</h3>
            <p class="chart-subtitle">Topic Authority, AI Readability, Content Clarity, Direct Answer Capability, Content Freshness, Semantic Understanding</p>
            <div class="chart-mobile-wrapper">
                <div class="combo-chart-wrapper">
                    <app-bar-line-combo-chart
                        [view]="chartView"
                        [scheme]="comboBarScheme"
                        [colorSchemeLine]="lineChartScheme"
                        [results]="resultsQuality"
                        [lineChart]="lineChartQuality"
                        [barBrandName]="(aiContentIndexResponse?.metadata?.your_brand || brands[0]?.name || 'Your Brand')"
                        [animations]="true"
                        [tooltipDisabled]="false"
                        [gradient]="false"
                        [xAxis]="true"
                        [yAxis]="true"
                        [legend]="true"
                        [legendTitle]="'Brands'"
                        [legendPosition]="'right'"
                        [showGridLines]="true"
                        [showXAxisLabel]="true"
                        [showYAxisLabel]="true"
                        [xAxisLabel]="'Quality Metric'"
                        [yAxisLabel]="'Score'"
                        [wrapTicks]="true"
                        (select)="onChartSelect($event)">
                    </app-bar-line-combo-chart>
                </div>
            </div>
        </div>
    </div>
    }

    <!-- Analysis Section -->
    @if (strengths.length > 0 || weaknesses.length > 0 || recommendations.length > 0) {
    <div class="analysis-section">
        <div class="analysis-grid">
            <!-- Strengths -->
            @if (strengths.length > 0) {
            <div class="analysis-card strengths">
                <h4>✅ Strengths</h4>
                <ul>
                    @for (strength of strengths; track strength) {
                    <li>{{ strength }}</li>
                    }
                </ul>
            </div>
            }

            <!-- Weaknesses -->
            @if (weaknesses.length > 0) {
            <div class="analysis-card weaknesses">
                <h4>⚠️ Areas for Improvement</h4>
                <ul>
                    @for (weakness of weaknesses; track weakness) {
                    <li>{{ weakness }}</li>
                    }
                </ul>
            </div>
            }

            <!-- Recommendations -->
            @if (recommendations.length > 0) {
            <div class="analysis-card recommendations">
                <h4>💡 Recommendations</h4>
                <div class="recommendations-list">
                    @for (rec of recommendations; track rec) {
                    <div class="recommendation-item">
                        <div class="recommendation-header">
                            <span class="priority-badge" [ngClass]="'priority-' + rec.priority?.toLowerCase()">
                                {{ rec.priority || 'Medium' }}
                            </span>
                            <span class="category-badge">{{ rec.category || 'General' }}</span>
                        </div>
                        <h5 class="issue-title">{{ rec.issue }}</h5>
                        <p class="recommendation-text">{{ rec.recommendation }}</p>
                        <div class="recommendation-footer">
                            <span class="expected-impact">Expected Impact: {{ rec.expected_impact }}</span>
                            @if (rec.target_score) {
                            <span class="target-score">Target Score: {{ rec.target_score }}</span>
                            }
                        </div>
                    </div>
                    }
                </div>
            </div>
            }
        </div>
    </div>
    }

    <!-- HIDDEN: Sources & Citations (do not remove)
    @if (evidenceSources.length > 0) {
    <app-citation-card
      [citations]="evidenceSources"
      [title]="'Sources & Citations'"
      [displayStyle]="'grid'"
      [maxDisplay]="6">
    </app-citation-card>
    }
    -->
</div>
}
